import deleteCalendarEventRequest from 'owa-service/lib/factory/deleteCalendarEventRequest';
import deleteCalendarEventOperation from 'owa-service/lib/operation/deleteCalendarEventOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import EventScope from 'owa-service/lib/contract/EventScope';
import { getDefaultRequestOptions } from 'owa-headers';
import itemId from 'owa-service/lib/factory/itemId';
import getCalendarEventRequest from 'owa-service/lib/factory/getCalendarEventRequest';
import getCalendarEventOperation from 'owa-service/lib/operation/getCalendarEventOperation';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import { getUserMailboxInfo } from 'owa-client-ids';

const onCloseRemoveDraftItem = (event: any) => {
    if (!event && event.data) {
        return;
    }
    const childWindowMessage = JSON.parse(event.data);
    if (childWindowMessage && childWindowMessage.source === 'calDraftItem') {
        removeCalendarDraftItem(childWindowMessage.id);
    }
};

export default function removeDraftCalendarMeetingService() {
    window.addEventListener('message', onCloseRemoveDraftItem);
}

/**
 * Remove the newly created calendar draft item on user calendar if
 * it has not been sent yet. It will not remove calendar event that
 * has been sent out.
 * */
async function removeCalendarDraftItem(calendarItemId: string) {
    if (calendarItemId) {
        const isDraft = await isDraftCalendarItem(calendarItemId);
        if (isDraft) {
            const body = deleteCalendarEventRequest({
                EventId: itemId({ Id: calendarItemId }),
                EventScope: EventScope.ThisInstanceOnly,
            });

            await deleteCalendarEventOperation(
                { Header: getJsonRequestHeader(), Body: body },
                await getDefaultRequestOptions(getUserMailboxInfo())
            );

            window.removeEventListener('message', onCloseRemoveDraftItem);
        }
    }
}

// Determines if the given calendar event is a draft item
async function isDraftCalendarItem(calendarItemId: string) {
    const response = await getCalendarEventOperation({
        Header: getJsonRequestHeader(),
        Body: getCalendarEventRequest({
            EventIds: [itemId({ Id: calendarItemId })],
            ItemShape: { BaseShape: 'IdOnly' },
        }),
    });

    if (response?.Body?.ResponseMessages) {
        const responseMessage = response.Body.ResponseMessages.Items[0] as ItemInfoResponseMessage;

        if (responseMessage) {
            return responseMessage.Items[0].IsDraft;
        }
    }
    return false;
}
